export default __webpack_public_path__ + "static/media/rectangle.74ae4505.png";